import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-6" }
const _hoisted_2 = { class: "m-0 rounded-lg border border-gray-200 bg-[#f9fafb] px-6 py-5 text-[17px] leading-7 text-gray-800" }
const _hoisted_3 = {
  key: 0,
  "data-errors": "",
  role: "alert",
  class: "m-0 rounded-lg bg-red-50 px-4 py-3 text-sm text-red-700"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { "data-set-up": "" }
const _hoisted_6 = { class: "rounded-lg border border-gray-300" }
const _hoisted_7 = { class: "pt-0.5 text-[#10b981]" }
const _hoisted_8 = { class: "min-w-0" }
const _hoisted_9 = { class: "text-sm font-semibold text-gray-900" }
const _hoisted_10 = { class: "text-[13px] text-gray-600" }

import { computed } from 'vue'

import DateCards from '@/components/neue/wizard/DateCards.vue'
import HighlightedText from '@/components/neue/wizard/HighlightedText'
import WizardIcon from '@/components/neue/wizard/WizardIcon.vue'
import { injectWizard } from '@/composables/useWizardContext'
import { dateCards } from '@/helpers/fulfillmentWizardSchedule'

const REVIEW_DATES = 3


export default {
  __name: 'StepReview',
  props: {
  description: { type: Object, required: true },
  setup: { type: Array, default: () => [] },
  errors: { type: Array, default: () => [] }
},
  setup(__props) {



const wizard = injectWizard()
const cards = computed(() =>
  dateCards(wizard.occurrences.value.slice(0, REVIEW_DATES), { type: wizard.data.type, tz: wizard.timeZone.value })
)

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, [
      _createVNode(_unref(HighlightedText), {
        text: __props.description.sentence
      }, null, 8, ["text"])
    ]),
    (__props.errors.length)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.errors, (error) => {
            return (_openBlock(), _createElementBlock("li", { key: error }, _toDisplayString(error), 1))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (cards.value.length)
      ? (_openBlock(), _createElementBlock("section", _hoisted_4, [
          _cache[0] || (_cache[0] = _createElementVNode("h3", { class: "m-0 mb-2 text-base font-bold text-gray-800" }, "The first few dates", -1)),
          _createVNode(DateCards, { cards: cards.value }, null, 8, ["cards"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("section", _hoisted_5, [
      _cache[1] || (_cache[1] = _createElementVNode("h3", { class: "m-0 mb-2 text-base font-bold text-gray-800" }, "What we'll set up", -1)),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.setup, (item, i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.title,
            class: _normalizeClass(["flex items-start gap-3 px-3.5 py-3", i ? 'border-t border-[#f3f4f6]' : ''])
          }, [
            _createElementVNode("span", _hoisted_7, [
              _createVNode(WizardIcon, { name: "check" })
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_unref(HighlightedText), {
                  text: item.title
                }, null, 8, ["text"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_unref(HighlightedText), {
                  text: item.text
                }, null, 8, ["text"])
              ])
            ])
          ], 2))
        }), 128))
      ])
    ])
  ]))
}
}

}